import React, { FC } from 'react';
import { SCUIGeneralModal } from '../../../../atomic/molecules';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCR } from '../../shippingCompanyRequest.classes';

export const SCUIShippingCompanyRequestAddToListModal: FC<{
    open: boolean;
    onClose: any;
    orderNo: string;
    setOrderNo: any;
    listele: any;
}> = ({ open, onClose, orderNo, setOrderNo, listele }) => {
    const { t } = useTranslation();

    return (
        <SCUIGeneralModal
            rootClassName={SCR.batchModal}
            paperClassName={SCR.batchModalPaper}
            titleClassName={SCR.batchModalTitle}
            closeIconButtonClassName={SCR.batchModalClose}
            width={'xs'}
            open={open}
            onClose={onClose}
            title={t('general.batchSearch')}
            functionButtonOnClick={listele}
            buttonText={t('general.search')}
        >
            <Grid container sx={{ padding: '2rem' }} className={SCR.batchModalBody}>
                <TextField
                    className={SCR.inputBatchOrderNo}
                    sx={{ paddingBottom: '1rem' }}
                    label={t('general.shipping') + ' No'}
                    value={orderNo}
                    multiline
                    rows={10}
                    onChange={(event: any) => {
                        setOrderNo(event.target.value);
                    }}
                    slotProps={{
                        inputLabel: {
                            shrink: true,
                        },
                    }}
                    fullWidth
                />
            </Grid>
        </SCUIGeneralModal>
    );
};
